<template>
  <Submenu :name="`${parentName}`">
    <template slot="title">
      <span>{{ showTitle(parentItem) }}</span>
    </template>
    <template v-for="item in children">
      <template v-if="!item.children">

        <router-link :to="{name:item.name}">
          <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
          <menu-item v-else :name="getNameOrHref(item)" :key="`menu-${item.name}`">
            <!--<common-icon />-->
            <span>{{ showTitle(item) }}</span>
          </menu-item>
        </router-link>

      </template>
      <template v-else>
        <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
      </template>
    </template>
  </Submenu>
</template>
<script>
  import mixin from './mixin'
  import itemMixin from './item-mixin'

  export default {
    name: 'SideMenuItem',
    mixins: [mixin, itemMixin],
  }
</script>



// WEBPACK FOOTER //
// src/components/main/components/side-menu/side-menu-item.vue